import type { UserRole } from '../../utils/rbac';

/**
 * The only roles a person may give themselves by signing up.
 *
 * This mirrors the `allow create` guard in firestore.rules. Every other role
 * (admin, superadmin, principal, associate, partner, and the internal staff
 * roles) is provisioned server-side through the Admin SDK. Keeping the client
 * list in step with the rule is what stops a role the rules will reject from
 * ever reaching a write — the rule is the boundary, this is the early exit.
 */
export const SELF_SIGNUP_ROLES: readonly UserRole[] = ['student', 'teacher', 'school'];

/**
 * Resolve the role a new user document should carry.
 *
 * Signup.jsx lets a person pick student / teacher / school and passes that
 * through. Anything else — absent, unrecognised, or a privileged role someone
 * tried to force — falls back to 'student', the least-privileged option.
 */
export function resolveSignupRole(requested: UserRole | null | undefined): UserRole {
  return requested && SELF_SIGNUP_ROLES.includes(requested) ? requested : 'student';
}
